export default __webpack_public_path__ + "static/media/himanshu.e245d8d0.jpeg";